<template>
  <div>
    <TitlePage :title="$t('calendar')+' '+$t('field')+' - '+description"></TitlePage>

    <v-layout wrap>

      <v-tabs v-model="tab" background-color="accent" dark touchless>
        <v-tabs-slider color="green"></v-tabs-slider>

        <v-tab href="#tab-1" @click="goToSettings">
          <v-icon small class="mr-2">mdi-calendar</v-icon>
          {{ $t('settings') }} {{ $t('masterCalendar') }}
        </v-tab>

        <v-tab href="#tab-2">
          <v-icon small class="mr-2">mdi-calendar</v-icon>
          {{ $t('calendar') }}
        </v-tab>

      </v-tabs>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item :value="'tab-1'">

        </v-tab-item>
        <v-tab-item :value="'tab-2'">

          <v-card v-if="item.master_calendar" class="calendar-full">

            <v-slide-group>
              <v-slide-item v-for="day in this.calendar.days" :key="day.toLocaleString()">


                <div class="item-calendar">
                  <v-btn depressed block color="accent" small text style="background:#e4dcff">
                    {{ day.toLocaleDateString('it-IT', {weekday: 'short'}) }} <span
                      style="font-size: 24px;margin: 0 15px;">{{ day.getDate() }}</span> {{
                      day.toLocaleDateString('it-IT', {month: 'short'})
                    }}
                  </v-btn>


                  <v-alert class="box-calendar" v-for="slot in item.master_calendar[day.getDay()]" dense text
                           :key="day.toLocaleString()+slot.id"
                           v-bind:class="[getAvailability(day,slot.id) ? 'available' : 'not-available', isSelected(day,slot.id) ? 'selected':'', isBooked(day, slot.id) ? 'booked':'']"
                           border="left"
                           colored-border
                           :color="getAvailabilityNow(day,slot.id) ? 'success' : 'error'"
                           @click="overrideSlot(day, slot)"
                  >
                    <div v-html="getSlotDetail(day,slot.id)"></div>

                  </v-alert>

                </div>


              </v-slide-item>
            </v-slide-group>


          </v-card>
          <v-card v-else elevation="0" outlined>
            <v-card-text>
              <p>{{ $t('setupMaster') }}</p>
            </v-card-text>
          </v-card>

          <v-flex md12 class="pt-10 d-flex">
            <v-divider class="marg-title"></v-divider>
          </v-flex>
          <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
            <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
              <v-icon left>mdi-keyboard-backspace</v-icon>
              {{ $t('back') }}
            </v-btn>
            <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
              {{ $t('save') }}
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-flex>

        </v-tab-item>
      </v-tabs-items>

    </v-layout>


    <v-dialog v-model="dialog_promo" persistent max-width="800px" v-if="slot_to_override">
      <v-card>
        <v-card-title>
          <span class="font-weight-bold">{{ this.override_title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <template>
                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{ $t('status') }}</v-chip>
                </v-flex>
                <v-flex md12 xs12 class="d-flex mt-2 mb-2">
                  <v-checkbox dense hide-details v-model="slot_to_override.status_slot"
                              :label="(slot_to_override.status_slot) ? this.$t('enabled') : this.$t('disabled')"
                              style="margin-top: 0">
                  </v-checkbox>
                </v-flex>
                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{ $t('splitPayment') }}
                  </v-chip>
                </v-flex>

                <v-flex md12 xs12 class="d-flex mt-2 mb-2" v-if="getUser.super_admin">
                  <v-checkbox dense hide-details v-model="slot_to_override.promo_sa"
                              :label="this.$t('enablePromoSuperAdmin')" style="margin-top: 0"
                              @change="changePromoSuperAdmin">
                  </v-checkbox>
                </v-flex>

                <v-flex md12 xs12 class="d-flex mt-2 mb-2">
                  <v-checkbox dense hide-details v-model="slot_to_override.split_payment_custom"
                              :label="this.$t('enableSplitPaymentCustom')" style="margin-top: 0">
                  </v-checkbox>
                </v-flex>

                <template v-if="slot_to_override.split_payment_custom">
                  <v-flex xs12 md4 class="pl-4 pr-4">
                    <v-select :items="split_payment_types" :label="$t('mode')"
                              @change="applySplitOverride"
                              v-model="split_payment_override_selected"></v-select>
                  </v-flex>
                  <v-flex xs12 md4 class="pl-4 pr-4">
                    <v-text-field type="number" :label="$t('onlinePercentage')"
                                  v-model="slot_to_override.split_payment.online_percentage"
                                  prefix="%" step="1"
                                  @input="changePercentageOverride('online')" min="0"
                                  max="100"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="pl-4 pr-4">
                    <v-text-field type="number" :label="$t('centerPercentage')"
                                  v-model="slot_to_override.split_payment.center_percentage"
                                  prefix="%" step="1"
                                  @input="changePercentageOverride('center')" min="0"
                                  max="100"></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs12 md12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{ $tc('promotion') }}
                  </v-chip>
                </v-flex>
                <v-flex xs12 md12 class="d-flex mt-2 mb-2">
                  <v-checkbox dense hide-details v-model="slot_to_override.promo_custom"
                              :label="this.$t('enablePromoCustom')" style="margin-top: 0"
                              @change="changePromoCustom">
                  </v-checkbox>
                </v-flex>
                <template v-if="slot_to_override.promo_custom">
                  <v-flex xs12 md4 class="pl-4 pr-4">
                    <v-select :items="promotion_types" :label="$t('mode')"
                              v-model="slot_to_override.promo.type"
                              @change="calculateTotalsOverride"></v-select>
                  </v-flex>
                  <v-flex xs12 md4 class="pl-4 pr-4" v-if="slot_to_override.promo.type !== null">
                    <v-text-field type="number" :label="$t('value')"
                                  v-model="slot_to_override.promo.value"
                                  :prefix="(slot_to_override.promo.type === 'fixed') ? '-':'%'"
                                  step="1"
                                  @input="calculateTotalsOverride" min="0" max="100"></v-text-field>
                  </v-flex>
                </template>

                <v-flex xs12 md12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{ $t('preview') }}</v-chip>
                </v-flex>

                <v-flex xs12 md12 class="pl-4 pr-4 pb-3">
                  <v-simple-table dense>
                    <thead>
                    <tr>
                      <th class="text-left">Sport</th>
                      <th class="text-left">Da Pagare Online</th>
                      <th class="text-left">Da Pagare al Campo</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="preview_ov in preview_price_override"
                        :key="'preview_ov_'+preview_ov.sport_id">
                      <td class="font-weight-bold">{{ getSportName(preview_ov.sport_id) }}</td>
                      <td>
                          <span v-bind:style="[+preview_ov.value_ac < +item.rules.min_price? {'color':'red'} : {}]">
                          <template v-if="+preview_ov.value_ac < +item.rules.min_price">*</template> {{
                              preview_ov.value_ac.toFixed(2)
                            }} €
                          </span>
                      </td>
                      <td>{{ preview_ov.value_ce.toFixed(2) }} €</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                  <small style="color: red">* Al di sotto del minimo costo garantito</small>

                </v-flex>

              </template>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="buttons-group-mobile">
          <v-btn color="secondary" text @click="dialog_promo = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="deletePromotion()" v-if="slot_to_override.id !== ''">
            {{ $t('delete') }}
          </v-btn>
          <v-btn color="primary" @click="updatePromotion()" v-if="slot_to_override.id !== ''">
            {{ $t('save') }}
          </v-btn>
          <v-btn color="primary" @click="savePromotion()" v-if="slot_to_override.id === ''">
            {{ $t('insert') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

// Dom -> 0
// Lun -> 1
// ....
// Sab -> 6

export default {
  name: "CalendarField",
  components: {TitlePage},
  data() {
    return {
      slot_selected: '',
      override_title: '',
      tab: 'tab-2',
      description: '',
      calendar: {
        days: []
      },
      item: {
        rules: {
          slot_time: 60,
          open_time: '',
          close_time: '',
          limit_time: 60,
          calendar_days_view: 10,
          min_price: 0
        },
        availability: [
          [], [], [], [], [], [], []
        ],
        time_slots: [],
        master_calendar: null,
        master_calendar_enabled: null,
        price: [],
        split_payment_master: {
          online_percentage: 0,
          center_percentage: 0
        }
      },
      master_calendar_depth: 0,
      sports: [],
      headers: [
        {name: 'Lunedì', day: 1},
        {name: 'Martedì', day: 2},
        {name: 'Mercoledì', day: 3},
        {name: 'Giovedì', day: 4},
        {name: 'Venerdì', day: 5},
        {name: 'Sabato', day: 6},
        {name: 'Domenica', day: 0},
      ],
      check: true,
      errors: {},
      validation: {},
      preview_price: [],
      preview_price_override: [],
      pathSettings: '/fields/settings/' + this.$route.params.id,
      dialog_promo: false,
      slot_to_override: null,
      field_id: '',
      center_id: '',
      split_payment_types: [
        {'text': this.$t('payDivide'), 'value': 'pay_divide'},
        {'text': this.$t('payCenter'), 'value': 'pay_center'},
        {'text': this.$t('payOnline'), 'value': 'pay_online'}
      ],
      promotion_types: [
        {'text': '', 'value': null},
        {'text': this.$t('fixed'), 'value': 'fixed'},
        {'text': this.$t('percentage'), 'value': 'percentage'},
      ],
      split_payment_override_selected: '',
      promotion_override_selected: '',
      promotions_active: [],
      bookings_active: []
    };
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser': 'user/getUser'
    }),
  },
  async created() {
    this.setLoading(true);
    this.sports = await this.getItemsSports()
    let fetchItem = await this.editItem(this.$route.params)

    for (let i = 0; i < 7; i++) {
      if (fetchItem.result.master_calendar[i].length > this.master_calendar_depth) {
        this.master_calendar_depth = fetchItem.result.master_calendar[i].length
      }
    }

    this.item.master_calendar = fetchItem.result.master_calendar
    this.item.master_calendar_enabled = fetchItem.result.master_calendar_enabled

    this.description = fetchItem.result.name + ' [' + fetchItem.result.center.name + ']'

    this.center_id = fetchItem.result.center._id
    this.field_id = fetchItem.result._id

    // this.item.availability = fetchItem.result.availability
    //
    if (!this.item.master_calendar || this.item.master_calendar.length === 0) {
      this.setLoading(false);
      return false
    }

    _.assign(this.item.rules, fetchItem.result.rules);
    // _.assign(this.item.time_slots, fetchItem.result.time_slots);
    _.assign(this.item.price, fetchItem.result.price);

    this.item.split_payment_master.online_percentage = (fetchItem.result.split_payment_master) ? fetchItem.result.split_payment_master.online_percentage : null
    this.item.split_payment_master.center_percentage = (fetchItem.result.split_payment_master) ? fetchItem.result.split_payment_master.center_percentage : null

    fetchItem.result.sports.map((s) => {
      this.preview_price.push({
        sport_id: s,
        value_ac: 0.00,
        value_ce: 0.00,
        sport: this.getSportName(s)
      })
      this.preview_price_override.push({
        sport_id: s,
        value_ac: 0.00,
        value_ce: 0.00,
        sport: this.getSportName(s)
      })
    })

    await this.fetchPromotions()
    await this.calculateTotals()
    await this.fetchBookings()
    await this.createCalendar()
    await this.applyBookings()

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'getItemsSports': 'sports/index',
      'editItem': 'fields/edit',
      'updateItem': 'fields/update',
      'storePromotion': 'promotions/store',
      'updatePromo': 'promotions/update',
      'deletePromo': 'promotions/delete',
      'getActivePromotions': 'promotions/getActivePromotions',
      'getActiveBookings': 'bookings/getActiveBookings',
    }),
    async update() {

      await this.checkItem()
      if (!this.check) {
        return
      } else {
        await this.resetError()
      }

      await this.setLoading(true);
      let result = await this.updateItem({...this.$route.params, item: this.item})
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }

    },
    async savePromotion() {

      await this.checkItem()
      if (!this.check) {
        return
      } else {
        await this.resetError()
      }

      await this.setLoading(true);
      let result = await this.storePromotion(this.slot_to_override)
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('createSuccess')
        })

        await this.fetchPromotions()
        this.dialog_promo = false
        this.$forceUpdate();


      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        })

      }


    },
    async updatePromotion() {

      await this.checkItem()
      if (!this.check) {
        return
      } else {
        await this.resetError()
      }

      await this.setLoading(true);
      let result = await this.updatePromo({id: this.slot_to_override.id, item: this.slot_to_override})
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

        await this.fetchPromotions()

        this.dialog_promo = false
        this.$forceUpdate();

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        })

      }


    },
    async deletePromotion() {

      await this.checkItem()
      if (!this.check) {
        return
      } else {
        await this.resetError()
      }

      await this.setLoading(true);
      let result = await this.deletePromo({id: this.slot_to_override.id})
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('deleteSuccess')
        })

        await this.fetchPromotions()

        this.dialog_promo = false
        this.$forceUpdate();

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(result)
        })

      }


    },

    async overrideSlot(day, timeslot) {

      let now_av = this.getAvailabilityNow(day, timeslot.id)
      if (!now_av) {
        return
      }

      let find = _.find(this.item.master_calendar[day.getDay()], {id: timeslot.id})

      let slot_id = `${day.getDate().toString().padStart(2, '0')};`;
      slot_id += `${(day.getUTCMonth() + 1).toString().padStart(2, '0')};`;
      slot_id += `${day.getFullYear()};`;
      slot_id += `${timeslot.id}`;

      let find_promo = _.find(this.promotions_active, {'slot_id': slot_id})
      let find_booking = _.find(this.bookings_active, {'slot_id': slot_id})

      if (find_booking) {
        await this.$router.push('/bookings/edit/' + find_booking._id)
        return
      }

      if (find_promo && find_promo.promo_sa && !this.getUser.super_admin) {
        return
      }

      this.override_title = day.toLocaleDateString() + ' | ' + timeslot.start + ' - ' + timeslot.end + ' | ' + this.description
      this.slot_selected = slot_id

      this.slot_to_override = {
        center_id: this.center_id,
        field_id: this.field_id,
        slot_id: slot_id,
        date: day.toISOString(),
        start_time: timeslot.start,
        end_time: timeslot.end,
        split_payment_custom: !!(find && find.split_payment),
        split_payment: {
          online_percentage: (find && find.split_payment && find.split_payment.online_percentage) ? +find.split_payment.online_percentage : 0.00,
          center_percentage: (find && find.split_payment && find.split_payment.center_percentage) ? +find.split_payment.center_percentage : 0.00
        },
        promo_custom: !!(find && find.promo),
        promo_sa: false,
        promo: {
          type: (find && find.promo && find.promo.type) ? find.promo.type : '',
          value: (find && find.promo && find.promo.value) ? +find.promo.value : 0.00,
        },
        status_slot: !!find,
        id: '',
        slot_price: (find.slot_price) ? find.slot_price : null
      }

      if (find_promo) {
        this.slot_to_override.split_payment_custom = find_promo.split_payment_custom
        this.slot_to_override.split_payment = find_promo.split_payment
        this.slot_to_override.promo_custom = find_promo.promo_custom
        this.slot_to_override.promo_sa = find_promo.promo_sa
        this.slot_to_override.promo = find_promo.promo
        this.slot_to_override.status_slot = find_promo.status_slot
        this.slot_to_override.id = find_promo._id
      }

      await this.calculateTotalsOverride()

      this.dialog_promo = true
    },

    async createCalendar() {

      for (let i = 0; i < 30; i++) {
        let date = new Date();
        date.setDate(date.getDate() + i);
        this.calendar.days.push(date)
      }

    },

    async checkItem() {
      this.check = true
    },

    async resetError() {
      this.errors = {}
    },

    getSportName(_id) {
      let find = _.find(this.sports, {'_id': _id})
      if (find) {
        return find.name
      } else {
        return _id
      }
    },

    isSelected(day, id) {

      let slot_id = `${day.getDate().toString().padStart(2, '0')};`;
      slot_id += `${(day.getUTCMonth() + 1).toString().padStart(2, '0')};`;
      slot_id += `${day.getFullYear()};`;
      slot_id += `${id}`;

      return (this.slot_selected === slot_id)
    },

    getAvailability(day, id) {
      let find = _.find(this.item.master_calendar[day.getDay()], {id: id})

      let slot_id = `${day.getDate().toString().padStart(2, '0')};`;
      slot_id += `${(day.getUTCMonth() + 1).toString().padStart(2, '0')};`;
      slot_id += `${day.getFullYear()};`;
      slot_id += `${id}`;
      let find_promo = _.find(this.promotions_active, {'slot_id': slot_id})
      let find_booking = _.find(this.bookings_active, {'slot_id': slot_id})

      if (find_booking) {
        return false
      }

      if (find_promo) {
        return find_promo.status_slot
      } else {
        return !!find;
      }

    },

    isBooked(day, id) {
      let slot_id = `${day.getDate().toString().padStart(2, '0')};`;
      slot_id += `${(day.getUTCMonth() + 1).toString().padStart(2, '0')};`;
      slot_id += `${day.getFullYear()};`;
      slot_id += `${id}`;
      let find_booking = _.find(this.bookings_active, {'slot_id': slot_id})
      return !!find_booking
    },

    getAvailabilityNow(day, id) {

      let start_time = id.split(';')
      let split = start_time[0].split(':');
      const now = new Date();
      now.setMinutes(now.getMinutes() + this.item.rules.limit_time);
      day.setHours(split[0], split[1], 0)

      return now <= day;

    },

    getSlotDetail(day, id) {
      let html = ''
      let find = _.find(this.item.master_calendar[day.getDay()], {id: id})

      let slot_id = `${day.getDate().toString().padStart(2, '0')};`;
      slot_id += `${(day.getUTCMonth() + 1).toString().padStart(2, '0')};`;
      slot_id += `${day.getFullYear()};`;
      slot_id += `${id}`;
      let find_promo = _.find(this.promotions_active, {'slot_id': slot_id})
      let find_booking = _.find(this.bookings_active, {'slot_id': slot_id})

      if (find_booking) {
        html += '<span class="time-slot">H/ ' + id.replace(';', ' - ') + '</span>'
        html += `<span class="split-payment font-weight-bold">Pren. COD. ${find_booking.code}</span>`
        return html
      }
      if ((find && find.active) || (find_promo && find_promo.status_slot)) {

        let info
        if (find_promo) {
          info = this.getSlotInfoFromPromo(find_promo)
        } else {
          info = this.getSlotInfo(find)
        }

        html += '<span class="time-slot">H/ ' + info.start + ' - ' + info.end + '</span>'

        if (info.promo && info.promo.value) {
          html += `<span class="promo-payment">Sconto: -${info.promo.value} ${(info.promo.type === 'fixed') ? '€' : '%'}</span>`
        }

        if (info.split_payment_custom) {
          html += `<span class="split-payment custom">SP/ Online: ${info.split_payment.online_percentage}% - Centro ${info.split_payment.center_percentage}%</span>`
        } else {
          html += `<span class="split-payment">SP/ Online: ${info.split_payment.online_percentage}% - Centro ${info.split_payment.center_percentage}%</span>`
        }

        if (info.id !== '') {
          if (!info.status_slot) {
            html += `<span class="promo-admin"> ${this.$t('disabled')}</span>`
          } else if (info.promo_sa) {
            html += `<span class="promo-admin"> ${this.$t('promoSuperAdmin')}</span>`
          } else if (info.promo_custom) {
            html += `<span class="promo-override"> ${this.$t('promotionActive')}</span>`
          }

        }


      } else {

        html += '<span class="time-slot">H/ ' + find.start + ' - ' + find.end + '</span>'
        html += `<span class="split-payment">Non in calendario</span>`

      }

      return html
    },

    getSlotInfo(slot) {
      let info = {}
      info.start = slot.start
      info.end = slot.end
      info.promo = {}
      info.split_payment_custom = false
      info.promo_sa = false
      info.id = ''
      info.status_slot = true

      if (slot.promo) {
        info.promo.value = slot.promo.value
        info.promo.type = slot.promo.type
      }

      if (slot.split_payment) {
        info.split_payment_custom = true
        info.split_payment = slot.split_payment
      } else {
        info.split_payment = this.item.split_payment_master
      }

      // if ((info.promo && info.promo.value) || info.split_payment_custom) {
      //     info.prices = this.calculateTotalsSlot(info)
      // } else {
      //     info.prices = []
      // }

      return info

    },

    getSlotInfoFromPromo(promo) {

      let slot = JSON.parse(JSON.stringify(promo))

      let info = {}
      info.start = slot.start_time
      info.end = slot.end_time
      info.promo = {}
      info.split_payment_custom = slot.split_payment_custom
      info.promo_sa = slot.promo_sa
      info.promo_custom = slot.promo_custom
      info.id = slot._id
      info.status_slot = slot.status_slot

      if (info.split_payment_custom) {
        info.split_payment_custom = true
        info.split_payment = slot.split_payment
      } else {
        info.split_payment = this.item.split_payment_master
      }

      if (slot.promo_custom) {
        info.promo.value = slot.promo.value
        info.promo.type = slot.promo.type
      }

      // if ((info.promo && info.promo.value) || info.split_payment_custom) {
      //     info.prices = this.calculateTotalsSlot(info)
      // } else {
      //     info.prices = []
      // }

      return info

    },

    async calculateTotals() {
      this.preview_price.map((p) => {
        let price = _.find(this.item.price, {'sport_id': p.sport_id})
        let unit = _.round(+price.value / 100, 3);
        let online = _.round(+unit * (+this.item.split_payment_master.online_percentage), 2);
        let center = _.round(+unit * (+this.item.split_payment_master.center_percentage), 2);
        p.value_ac = online
        p.value_ce = center
      })
    },

    calculateTotalsSlot(slot) {

      let prices = []

      this.preview_price.map((p) => {
        let find = _.find(this.item.price, {'sport_id': p.sport_id})
        let price = JSON.parse(JSON.stringify(find))

        if (slot.promo && slot.promo.type === 'fixed' && slot.promo.value >= 0.00) {
          price.value = price.value - slot.promo.value
        } else if (slot.promo && slot.promo.type === 'percentage' && slot.promo.value >= 0.00) {
          let discount_unit = _.round(+price.value / 100, 3);
          let discount = _.round(+discount_unit * (+slot.promo.value), 2);
          price.value = price.value - discount
        }

        let unit = _.round(+price.value / 100, 3);
        let online = _.round(+unit * (+slot.split_payment.online_percentage), 2);
        let center = _.round(+unit * (+slot.split_payment.center_percentage), 2);

        prices.push({
          value_ac: online,
          value_ce: center,
          sport: this.getSportName(p.sport_id)
        })
      })

      return prices
    },

    async fetchPromotions() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let promo = await this.getActivePromotions({field_id: this.field_id, date: today.toISOString()})
      this.promotions_active = promo.result
    },

    async fetchBookings() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let bookings = await this.getActiveBookings({field_id: this.field_id})
      this.bookings_active = bookings.result
    },

    async applyBookings() {
      this.bookings_active.map((booking) => {
        if (booking.added_30_min_before || booking.added_30_min_after) {
          let split = booking.slot_id.split(';')
          let start_time = split[3]
          let end_time = split[4]
          let search_start_time = start_time
          let search_end_time = end_time

          // restore old time
          if(booking.added_30_min_before){
            search_start_time = this.$moment(start_time, 'HH:mm').add(30, 'minutes').format('HH:mm');
          }else if(booking.added_30_min_after){
            search_end_time = this.$moment(end_time, 'HH:mm').subtract(30, 'minutes').format('HH:mm');
          }

          let date = new Date(booking.date)

        }
      })
    },

    async applySplitOverride() {
      switch (this.split_payment_override_selected) {
        case "pay_divide": {
          this.slot_to_override.split_payment.online_percentage = 50.00
          this.slot_to_override.split_payment.center_percentage = 50.00
          this.calculateTotalsOverride()
          break
        }
        case "pay_center": {
          this.slot_to_override.split_payment.online_percentage = 0.00
          this.slot_to_override.split_payment.center_percentage = 100.00
          await this.calculateTotalsOverride()
          break
        }
        case "pay_online": {
          this.slot_to_override.split_payment.online_percentage = 100.00
          this.slot_to_override.split_payment.center_percentage = 0.00
          await this.calculateTotalsOverride()
          break
        }
        default: {
          break
        }
      }
    },

    async calculateTotalsOverride() {

      this.preview_price_override = JSON.parse(JSON.stringify(this.preview_price))

      this.preview_price_override.map((p) => {
        let prices = (this.slot_to_override.slot_price) ? this.slot_to_override.slot_price : this.item.price
        let find = _.find(prices, {'sport_id': p.sport_id})
        let price = JSON.parse(JSON.stringify(find))

        if (this.slot_to_override.promo_custom) {
          if (this.slot_to_override.promo.type === 'fixed' && this.slot_to_override.promo.value >= 0.00) {
            price.value = +price.value - this.slot_to_override.promo.value
          } else if (this.slot_to_override.promo.type === 'percentage' && this.slot_to_override.promo.value >= 0.00) {
            let discount_unit = _.round(+price.value / 100, 3);
            let discount = _.round(+discount_unit * (+this.slot_to_override.promo.value), 2);
            price.value = +price.value - discount
          }
        }


        let online
        let center
        let unit = _.round(+price.value / 100, 3);
        if (this.slot_to_override.split_payment_custom) {
          online = _.round(+unit * (+this.slot_to_override.split_payment.online_percentage), 2);
          center = _.round(+unit * (+this.slot_to_override.split_payment.center_percentage), 2);
        } else {
          online = _.round(+unit * (+this.item.split_payment_master.online_percentage), 2);
          center = _.round(+unit * (+this.item.split_payment_master.center_percentage), 2);
        }

        p.value_ac = online
        p.value_ce = center
      })
    },

    async changePercentageOverride(type) {
      let total = 100.00
      if (type === 'online') {
        if (+this.slot_to_override.split_payment.online_percentage < 0) {
          this.slot_to_override.split_payment.online_percentage = 0.00
          this.slot_to_override.split_payment.center_percentage = 100.00
        } else if (+this.slot_to_override.split_payment.online_percentage > 100) {
          this.slot_to_override.split_payment.online_percentage = 100.00
          this.slot_to_override.split_payment.center_percentage = 0.00
        } else {
          this.slot_to_override.split_payment.center_percentage = +(total - (+this.slot_to_override.split_payment.online_percentage))
        }
      } else if (type === 'center') {
        if (+this.slot_to_override.split_payment.center_percentage < 0) {
          this.slot_to_override.split_payment.center_percentage = 0.00
          this.slot_to_override.split_payment.online_percentage = 100.00
        } else if (+this.slot_to_override.split_payment.center_percentage > 100) {
          this.slot_to_override.split_payment.center_percentage = 100.00
          this.slot_to_override.split_payment.online_percentage = 0.00
        } else {
          this.slot_to_override.split_payment.online_percentage = +(total - (+this.slot_to_override.split_payment.center_percentage))
        }
      }
      await this.calculateTotalsOverride()
      this.$forceUpdate();
    },

    changePromoSuperAdmin() {
      if (this.slot_to_override.promo_sa) {
        this.slot_to_override.split_payment.online_percentage = 100.00
        this.slot_to_override.split_payment.center_percentage = 0.00
        this.slot_to_override.split_payment_custom = true
        this.split_payment_override_selected = 'pay_online'
        this.calculateTotalsOverride()
      } else {
        this.slot_to_override.split_payment.online_percentage = (this.item.split_payment_master.online_percentage) ? this.item.split_payment_master.online_percentage : 50.00
        this.slot_to_override.split_payment.center_percentage = (this.item.split_payment_master.center_percentage) ? this.item.split_payment_master.center_percentage : 50.00
        this.slot_to_override.split_payment_custom = true
        this.split_payment_override_selected = ''
        this.calculateTotalsOverride()
      }
    },

    changePromoCustom() {
      if (this.slot_to_override.promo_custom) {

      } else {
        this.slot_to_override.promo.type = ''
        this.slot_to_override.promo.value = 0
        this.calculateTotalsOverride()
      }
    },

    goToSettings() {
      this.$router.push(this.pathSettings)
    },

  }
  ,
  mounted() {

  }
}
</script>

<style>
.item-calendar {
  width: 180px;
  margin: 0 5px;
  text-align: center;
  padding: 10px 0;
}

.time-slot {
  font-size: 12px;
  display: block;
  font-weight: 700;
}

.split-payment {
  font-size: 12px;
  display: block;
}

.split-payment.custom {
  font-weight: bold;
  display: block;
  color: #fe2f2f;
}

.promo-payment {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #fe2f2f;
}

.slot {
  margin: 5px auto;
  padding: 5px 0;
}

.available {
  color: #050025 !important;
  /*min-height: 125px;*/
}

.not-available {
  color: #4c4c4c !important;
  opacity: 0.4;
  /*min-height: 125px;*/
}

.bookable {
  border-left: 4px solid #2dde5ab3 !important;
}

.sport-price {
  font-size: 11px;
  display: block;
}

.box-calendar {
  padding: 5px 0 !important;
  margin: 5px 0 !important;
  cursor: pointer;
  min-height: 60px;
}

.available.v-alert--text:before {
  background-color: #2d396c !important
}

.not-available.error--text {
  color: #cbd2e8 !important;
}

.promo-override {
  background: yellow;
  font-size: 10px;
  padding: 5px;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: 600;
}

.promo-admin {
  background: rgba(228, 0, 0, 0.77);
  color: #fff;
  font-size: 10px;
  padding: 5px;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: 600;
}

.calendar-full .v-slide-group__next, .calendar-full .v-slide-group__prev {
  align-items: start;
  padding-top: 1%;
}

.calendar-full .selected {
  background: #e4dcff !important;
  border: 4px solid #e4dcff !important;
}

.calendar-full .booked {
  background: #62c9ff !important;
  color: #000 !important;
}
</style>